/**
 * "Войти как компания" (поддержка Data Metrics) — временно подменяет текущую
 * сессию в localStorage, сохранив исходную для возврата.
 */

const BACKUP_KEY = 'admin_session_backup';

export const startImpersonation = (token, company) => {
  const backup = {
    access_token: localStorage.getItem('access_token'),
    user: localStorage.getItem('user'),
    current_company: localStorage.getItem('current_company'),
  };
  localStorage.setItem(BACKUP_KEY, JSON.stringify(backup));

  localStorage.setItem('access_token', token);
  localStorage.setItem('current_company', JSON.stringify(company));
};

export const stopImpersonation = () => {
  const raw = localStorage.getItem(BACKUP_KEY);
  if (!raw) return;

  const backup = JSON.parse(raw);
  if (backup.access_token) localStorage.setItem('access_token', backup.access_token);
  if (backup.user) localStorage.setItem('user', backup.user);
  if (backup.current_company) localStorage.setItem('current_company', backup.current_company);
  localStorage.removeItem(BACKUP_KEY);
};

export const isImpersonating = () => localStorage.getItem(BACKUP_KEY) !== null;

export const getImpersonatedCompanyName = () => {
  try {
    return JSON.parse(localStorage.getItem('current_company'))?.name || null;
  } catch {
    return null;
  }
};
